import React, { Fragment, useState } from "react"
import { GenericDialog } from "../../components/generic/GenericDialog"
import { Box, Button, Grid2 as Grid, Stack, Typography } from "@mui/material"
import { GenericAvatar } from "../../components/generic/GenericAvatar"
import { ProfileInterests } from "../admin/adminHomePage/profileDetails/ProfileInterests"
import { COLLAB_INTEREST_NSFW, COLLAB_INTEREST_SFW, CONTENT_INTEREST_NSFW, CONTENT_INTEREST_SFW } from "../../enums/generalEnums"
import { acceptCollabRequest, rejectCollabRequest } from "../../config/apisauce"
import LoadingButton from "@mui/lab/LoadingButton"
import useNotiStack from "../../hooks/useNotiStack"
import { formatDate } from "../../helpers/dateHelper"
import { ACCEPTED, PENDING, STATUS_COLORS } from "../../enums/statusEnums"
import { toSlug } from "../../helpers/stringHelper"

export const CollabRequestDialog = (props) => {
  const {
    openCollabRequestDialog,
    handleCloseRequestDialog,
    collabRequestDetails,
    refetchData,
    viewOnly
  } = props;

  const { success } = useNotiStack();
  const titleProps = { fontSize: '16px', mb: 1.5, fontWeight: 700 }
  const [loadingReject, setIsLoadingReject] = useState(false);
  const [loadingAccept, setLoadingAccept] = useState(false);

  const handleAcceptRejectCollabRequest = async (isAccept) => {
    isAccept ? setLoadingAccept(true) : setIsLoadingReject(true);
    const params = {
      hash: collabRequestDetails?.fields?.hash
    };
    const response = isAccept ? await acceptCollabRequest(params) : await rejectCollabRequest(params);
    if (response.ok) {
      refetchData();
      handleCloseRequestDialog();
      isAccept ? success('Accepted collab request!') : success('Rejected collab request!');
    }
    isAccept ? setLoadingAccept(false) : setIsLoadingReject(false);
  };

  return (
    <GenericDialog
      width={'700px'}
      title={'Collab Invite'}
      openDialog={openCollabRequestDialog}
      handleClose={handleCloseRequestDialog}
    >
      <Box sx={{ padding: { xs: '0px', sm: '0px 32px' }, overflowX: 'auto' }}>
        {
          (viewOnly) ? <Fragment>
            <Typography variant="subtitle1" fontWeight={700}>Date Requested:</Typography>
            <Typography variant="subtitle1" mb={3}>{formatDate(collabRequestDetails?.created_at)}</Typography>
            <Grid container spacing={3} mb={4}>
              <Grid item size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" fontWeight={700}>Requested By:</Typography>
                <Stack direction={'row'} gap={1} alignItems={'center'} mt={1}>
                  <GenericAvatar
                    size={'42px'}
                    location={collabRequestDetails?.requested_by?.details?.profile_picture?.location}
                  />
                  <Typography variant="subtitle1">{collabRequestDetails?.requested_by?.name}</Typography>
                </Stack>
              </Grid>
              <Grid item size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" fontWeight={700}>Invite Received By:</Typography>
                <Stack direction={'row'} gap={1} alignItems={'center'} mt={1}>
                  <GenericAvatar
                    size={'42px'}
                    location={collabRequestDetails?.requested_to?.details?.profile_picture?.location}
                  />
                  <Typography variant="subtitle1">{collabRequestDetails?.requested_to?.name}</Typography>
                </Stack>
              </Grid>
            </Grid>
          </Fragment> : <Stack alignItems={'center'} gap={2} mb={3}>
            <GenericAvatar
              size={'128px'}
              location={collabRequestDetails?.requested_by?.details?.profile_picture?.location}
            />
            <Typography variant="h5" fontWeight={700} textAlign={'center'}>{collabRequestDetails?.requested_by?.name} wants to collab!</Typography>
          </Stack>
        }
        <ProfileInterests
          hideCard={true}
          titleProps={titleProps}
          title={'Collab Interest:'}
          isArrayOfObjects={false}
          sfwKey={COLLAB_INTEREST_SFW}
          nsfwKey={COLLAB_INTEREST_NSFW}
          minHeight={'120px'}
          sfwList={collabRequestDetails?.fields?.collaborate_interest_sfw}
          nsfwList={collabRequestDetails?.fields?.collaborate_interest_nsfw}
        />
        <ProfileInterests
          hideCard={true}
          titleProps={titleProps}
          title={'Content Interest:'}
          sfwKey={CONTENT_INTEREST_SFW}
          nsfwKey={CONTENT_INTEREST_NSFW}
          minHeight={'100px'}
          isArrayOfObjects={false}
          sfwList={collabRequestDetails?.fields?.content_interest_sfw}
          nsfwList={collabRequestDetails?.fields?.content_interest_nsfw}
        />
        <Typography {...titleProps} mt={2}>Details:</Typography>
        <Typography variant="subtitle1">{collabRequestDetails?.fields?.details}</Typography>
        {
          (viewOnly || collabRequestDetails?.status !== PENDING) && <Fragment>
            <Typography variant="subtitle1" fontWeight={700} mt={3}>Status:</Typography>
            <Typography fontWeight={700} textTransform={'capitalize'} color={STATUS_COLORS[collabRequestDetails?.status]}>{collabRequestDetails?.status}</Typography>
          </Fragment>
        }
      </Box>
      {
        (!viewOnly && collabRequestDetails?.status === PENDING) && <Fragment>
          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent={'center'} gap={1} mt={2}>
            <LoadingButton
              onClick={() => handleAcceptRejectCollabRequest(false)}
              loading={loadingReject}
              disabled={loadingReject || loadingAccept}
              variant="contained"
              color="error" sx={{ width: { xs: '100%', sm: '250px' } }}
            >
              Reject
            </LoadingButton>
            <LoadingButton
              onClick={() => handleAcceptRejectCollabRequest(true)}
              loading={loadingAccept}
              disabled={loadingReject || loadingAccept}
              variant="contained" color="success" sx={{ width: { xs: '100%', sm: '250px' } }}
            >
              Accept
            </LoadingButton>
          </Stack>
          <Box sx={{ mt: 2.5, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Button variant="outlined" sx={{ width: { xs: '100%', sm: '250px' } }} onClick={() => window.open(`/creator?user=${toSlug(collabRequestDetails?.requested_by?.name)}-${collabRequestDetails?.requested_by?.id}`, '_blank')}>View Their Profile</Button>
          </Box>
        </Fragment>
      }
      {
        (!viewOnly && collabRequestDetails?.status === ACCEPTED) && <Button
          variant="contained"
          sx={{ width: '100%', mt: 1.5 }}
          size={"large"}
          onClick={() => window.open(`/chats`, '_blank')}
        >
          Open Chat
        </Button>
      }
    </GenericDialog>
  )
};